import { render, staticRenderFns } from "./CampaignListItemBase.vue?vue&type=template&id=941e9202"
import script from "./CampaignListItemBase.vue?vue&type=script&lang=js"
export * from "./CampaignListItemBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports